import userQuery from '/opt/build/repo/node_modules/@evince/eshop/lib/graphql/queries/CurrentUser.gql'

export default ({ app, store }, inject) => {
  inject('user', {
    get data() {
      return store.getters['user/data'] || {}
    },
    get email() {
      return this.data.email
    },
    reset() {
      store.commit('user/RESET_USER')
    },
    async fetch() {
      try {
        const { data } = await app.$graphql.query({
          clientId: 'auth',
          query: userQuery
        })

        store.commit('user/UPDATE_USER', data)
      } catch (e) {
        console.log(e)
      }
    }
  })
}
